import React, { useState } from "react";
import FilterCustomerJourney from "../partials/actions/FilterCustomerJourney";
import AddEditOrganizationPopup from "../partials/dashboard/AddEditOrganizationPopup";
import CustomerJourneyManagementTable from "../partials/dashboard/CustomerJourneyManagementTable"
import CreateJourneyModal from "../partials/CustomerJourney/CreateJourneyModal";
import CreateIndustries from "../partials/Industry/CreateIndustries";

function CustomerJourneyManagement() {
  const [showPopup, setShowPopup] = useState(false);
  const [industriesType, setIndustriesType] = useState('');
  const [filteredData, setFilteredData] = useState("");
  const [showModal, setShowModal] = useState(false); // State to control modal visibility
  const [modalType, setModalType] = useState(""); // <-- soit "journey" soit "industry"

  const toggleModal = (type = "") => {
    setShowModal(!showModal);
    setModalType(type);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };
  const handleAdd = () => {
    // setShowPopup(true);
  };

  return (
    <>
      {/* Dashboard actions */}
            <div className=" flex justify-end mb-8">


              {/* Right: Actions */}
              <div className="grid grid-flow-col sm:auto-cols-max justify-end sm:justify-end gap-2">
                {/* Filter button */}
                <FilterCustomerJourney
                  setIndustriesType={setIndustriesType}
                  industriesType={industriesType}
                  filteredData={filteredData}
                  setFilteredData={setFilteredData}
                />
                {/*<Datepicker />*/}
                {/* Add view button */}
                <div className="flex flex-col gap-2">
                  <button
                    onClick={() => toggleModal("journey")}
                    className="bg-transparent hover:bg-indigo-500 text-indigo-700 font-semibold hover:text-white py-2 px-4 border border-indigo-500 hover:border-transparent rounded transition-colors duration-200"
                  >
                    Add Customer Journey
                  </button>


                  <button
                    onClick={() => toggleModal("industry")}
                    className="bg-transparent hover:bg-green-500 text-green-700 font-semibold hover:text-white py-2 px-4 border border-green-500 hover:border-transparent rounded transition-colors duration-200"
                  >
                    Add Industry
                  </button>

                </div>

              </div>
            </div>

            {/* Cards */}
            <div className="grid grid-cols-12 gap-6">
              <CustomerJourneyManagementTable
                setIndustriesType={setIndustriesType}
                industriesType={industriesType}
                filteredData={filteredData}
                setFilteredData={setFilteredData}
              />
            </div>

      {showPopup && (
        <AddEditOrganizationPopup customer={null} onClose={handleClosePopup} />
      )}
      {/* Button to open the modal */}
      { /*<button onClick={toggleModal}>Create Journey</button>*/}

      {/* Conditionally render the modal based on the showModal state */}
      {showModal && modalType === "journey" && (
        <CreateJourneyModal toggleModal={toggleModal} />
      )}

      {showModal && modalType === "industry" && (
        <CreateIndustries toggleModal={toggleModal} />
      )}
    </>
  );
}

export default CustomerJourneyManagement;
